import { useState, useEffect } from "react";
import { diaAnteriorSemana, diaSemana, formatSeconds, getSecondsByHour } from "../../js/functions";
import { PROJECT_APP, ECINNOVA, INSERTATOLEDO, CARITASTOLEDO } from "./../../js/project"

const MIN_PERCENTAJE = 16;
const MAX_PERCENTAJE = 20;

export default function HorasDiaSemana({ semana }) {
  const [tiempoDia, setTiempoDia] = useState(null)
  const [tiempoSemana, setTiempoSemana] = useState(null)
  
  const [labelDia, setLabelDia] = useState(null)
  const [labelDiaPresencial, setLabelDiaPresencial] = useState(null)
  const [labelDiaTeletrabajo, setLabelDiaTeletrabajo] = useState(null)
  
  const [labelSemana, setLabelSemana] = useState(null)
  const [labelSemanaPresencial, setLabelSemanaPresencial] = useState(null)
  const [labelSemanaTeletrabajo, setLabelSemanaTeletrabajo] = useState(null)

  const diaActual = diaSemana()
  const diaAnterior = diaAnteriorSemana()
  let fechaAlSegundo = new Date()
  let horaActual = `${new Date().getHours()}:${new Date().getMinutes()}`

  const [showModal, setShowModal] = useState(false);
  const [hasModalBeenSeen, setHasModalBeenSeen] = useState(false);

  useEffect(() => {
    // intervalo()
    horasMinutosDia()
    horasMinutosSemanales()
    porcentajeHorasDia()
    porcentajeHorasSemana()
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fechaAlSegundo = new Date()
      horaActual = `${fechaAlSegundo.getHours()}:${fechaAlSegundo.getMinutes()}`
      porcentajeHorasDia()
      porcentajeHorasSemana()

      if (diaSemana() !== diaActual) {
        window.location.reload()
      }
      if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
        // NO HACER NADA
      }
      else if (PROJECT_APP === CARITASTOLEDO) {
        if (showModal === false && hasModalBeenSeen === false && (getSecondsByHour(horaActual) === getSecondsByHour(semana[diaActual].horario.fin) + 900 || getSecondsByHour(horaActual) === getSecondsByHour(semana[diaActual].horario.finTarde) + 900)) {
          setShowModal(true);
        }
      }
    }, 1000);

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar
  }, [showModal, hasModalBeenSeen]);

  function horasMinutosDia() {
    let diaActualOAnterior = diaActual
    if (semana[diaAnterior].registro !== undefined &&
        semana[diaAnterior].registro.inicio !== undefined &&
        semana[diaAnterior].registro.fin === undefined) {
      diaActualOAnterior = diaAnterior
    }
    else {
      diaActualOAnterior = diaActual
    }
    // if (semana[diaActualOAnterior].horario.inicio === "") {
    //   setTiempoDia("00:00")
    //   return
    // } 
    
    let minutosInicio = 0
    let minutosFin = 0

    if (semana[diaActualOAnterior].horario.inicio !== "") {
      const arrIni = (semana[diaActualOAnterior].horario.inicio).split(":")
      const arrFin = (semana[diaActualOAnterior].horario.fin).split(":")
      minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
      minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
    }

    let minutosTotalesTarde = 0

    if (semana[diaActualOAnterior].horario.inicioTarde !== "") {
      const arrIniTarde = (semana[diaActualOAnterior].horario.inicioTarde).split(":")
      const arrFinTarde = (semana[diaActualOAnterior].horario.finTarde).split(":")
      const minutosInicioTarde = parseInt(arrIniTarde[0]) * 60 + parseInt(arrIniTarde[1])
      const minutosFinTarde = parseInt(arrFinTarde[0]) * 60 + parseInt(arrFinTarde[1])
      minutosTotalesTarde = minutosFinTarde - minutosInicioTarde
    }

    let minutosTotalesDiarios = 0

    if (semana[diaActualOAnterior].horario.dobleDia === true) {
      minutosTotalesDiarios = minutosFin + 1440 - minutosInicio
    }
    else {
      minutosTotalesDiarios = minutosFin - minutosInicio + minutosTotalesTarde
    }
    
    
    let horasDiarias = ""
    let minutosDiarios = ""
    
    if (minutosTotalesDiarios/60 < 10) {
      horasDiarias = `0${parseInt(minutosTotalesDiarios/60)}`
    }
    else {
      horasDiarias = `${parseInt(minutosTotalesDiarios/60)}`
    }
    if (minutosTotalesDiarios%60 < 10) {
      minutosDiarios = `0${parseInt(minutosTotalesDiarios%60)}`
    }
    else {
      minutosDiarios = `${parseInt(minutosTotalesDiarios%60)}`
    }
    setTiempoDia(`${horasDiarias}:${minutosDiarios}`)
  }

  function calcHorasSemanales(diaSemanaFor) {
    if (semana[diaSemanaFor].horario.inicio !== "") {
      if(semana[diaSemanaFor].horario.dobleDia === true) {
        const arrIni = (semana[diaSemanaFor].horario.inicio).split(":")
        const arrFin = (semana[diaSemanaFor].horario.fin).split(":")
        const minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
        const minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
        return minutosFin + 1440 - minutosInicio
      }
      if(semana[diaSemanaFor].horario.inicioTarde !== "") {
        const arrIni = (semana[diaSemanaFor].horario.inicio).split(":")
        const arrFin = (semana[diaSemanaFor].horario.fin).split(":")
        const arrIniTarde = (semana[diaSemanaFor].horario.inicioTarde).split(":")
        const arrFinTarde = (semana[diaSemanaFor].horario.finTarde).split(":")

        const minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
        const minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
        const minutosInicioTarde = parseInt(arrIniTarde[0]) * 60 + parseInt(arrIniTarde[1])
        const minutosFinTarde = parseInt(arrFinTarde[0]) * 60 + parseInt(arrFinTarde[1])
        return ((minutosFin - minutosInicio) + (minutosFinTarde - minutosInicioTarde));
      }
      else {
        const arrIni = (semana[diaSemanaFor].horario.inicio).split(":")
        const arrFin = (semana[diaSemanaFor].horario.fin).split(":")
        const minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
        const minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
        return minutosFin - minutosInicio
      }
    } else return 0
  }

  function horasMinutosSemanales() {
    let minutosTotalesSemanales = 0;
    let horasSemanales = ""
    let minutosSemanales = ""
    for(let i=1; i<=7; i++) {
      minutosTotalesSemanales = calcHorasSemanales(i) + minutosTotalesSemanales
    }
    
    if (minutosTotalesSemanales/60 < 10) {
      horasSemanales = `0${parseInt(minutosTotalesSemanales/60)}`
    }
    else {
      horasSemanales = `${parseInt(minutosTotalesSemanales/60)}`
    }
    if (minutosTotalesSemanales%60 < 10) {
      minutosSemanales = `0${parseInt(minutosTotalesSemanales%60)}`
    }
    else {
      minutosSemanales = `${parseInt(minutosTotalesSemanales%60)}`
    }

    setTiempoSemana(`${horasSemanales}:${minutosSemanales}`)
  }

  function calcPorcentajeHorasSemana(diaActualFor) {
    let pausasHoy = "", totalSegundosHoy = 0, totalSegundosHoyPresencial = 0, totalSegundosHoyTeletrabajo = 0;
    if (semana[diaActualFor].registro.pausas !== undefined && semana[diaActualFor].registro.pausas !== null) {
      if (semana[diaActualFor].registro !== "") {
        pausasHoy = semana[diaActualFor].registro.pausas.filter(pausa => pausa.tipo !== 2)
      }
      else {
        pausasHoy = ""
      }
    } 

    if (semana[diaActualFor].registro.inicio !== undefined) {
      if (pausasHoy !== "" && pausasHoy !== null && pausasHoy.length > 0) {
        for (let i = 0; i<pausasHoy.length; i++) {
          if (pausasHoy[i] !== undefined) {

            // hay 1 pausa con fin
            if (pausasHoy.length === 1 && semana[diaActualFor].registro.fin !== undefined) {
              // de inicio a pausasHoy[0]
              if (semana[diaActualFor].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              }

              // de pausasHoy[0] a fin
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= semana[diaActualFor].registro.fin.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= semana[diaActualFor].registro.fin.seconds - pausasHoy[0].fin.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              const segundosAux2 = semana[diaActualFor].registro.fin.seconds - pausasHoy[0].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2
              //totalHoy = formatSeconds(totalSegundosHoy)
              //console.log("una pausa")
            } 

            //hay 1 pausa sin registro.fin
            if (pausasHoy.length === 1 && 
              semana[diaActualFor].registro.fin === undefined && 
              pausasHoy[0].fin !== undefined && 
              (
                new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() || 
                new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() - 1
              )
              ) 
            { 
              // de inicio a pausasHoy[0]
              if (semana[diaActualFor].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              }

              // de pausasHoy[0] a horaactual
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= new Date().getTime() / 1000 - pausasHoy[0].fin.seconds
              }

              
              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              const segundosAux2 = new Date().getTime() / 1000 - pausasHoy[0].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2
              //console.log(totalSegundosHoy)
            } 

            //hay 1 pausa sin registro.fin y pausa activa
            if (pausasHoy.length === 1 && semana[diaActualFor].registro.fin === undefined && pausasHoy[0].fin === undefined) {
              // de inicio a pausasHoy[0]
              if (semana[diaActualFor].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              totalSegundosHoy = segundosAux
              //console.log(totalSegundosHoy)
            } 

            //hay 2 pausas con registro.fin
            if (pausasHoy.length === 2 && semana[diaActualFor].registro.fin !== undefined && (i === 0)/** Esto es para que no entre dos veces al tener dos pausas */ ) {
              // de inicio a pausasHoy[0]
              if (semana[diaActualFor].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              }

              // de pausasHoy[0] a pausasHoy[1]
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }

              // de pausasHoy[1] a fin
              if (pausasHoy[1].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= semana[diaActualFor].registro.fin.seconds - pausasHoy[1].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= semana[diaActualFor].registro.fin.seconds - pausasHoy[1].fin.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              const segundosAux2 = pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              const segundosAux3 = semana[diaActualFor].registro.fin.seconds - pausasHoy[1].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2 + segundosAux3
              //totalHoy = formatSeconds(totalSegundosHoy)
              //console.log("2 pausas")
            }

            //hay 2 pausas sin registro.fin
            if (pausasHoy.length === 2 && 
                semana[diaActualFor].registro.fin === undefined && 
                pausasHoy[1].fin !== undefined && 
                (
                  new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() || 
                  new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() - 1
                )
                && (i === 0)/** Esto es para que no entre dos veces al tener dos pausas */ 
                ) 
              { 
              // de inicio a pausasHoy[0]
              if (semana[diaActualFor].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              }

              // de pausasHoy[0] a pausasHoy[1]
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }

              // de pausasHoy[1] a horaactual
              if (pausasHoy[1].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - pausasHoy[1].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= new Date().getTime() / 1000 - pausasHoy[1].fin.seconds
              }


              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              const segundosAux2 = pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              const segundosAux3 = new Date().getTime() / 1000 - pausasHoy[1].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2 + segundosAux3
              //totalHoy = formatSeconds(totalSegundosHoy)
            }  

            //hay 2 pausas sin registro.fin y pausa activa
            if (pausasHoy.length === 2 && semana[diaActualFor].registro.fin === undefined && pausasHoy[1].fin === undefined && (i === 0)/** Esto es para que no entre dos veces al tener dos pausas */ ) { 
              // de inicio a pausasHoy[0]
              if (semana[diaActualFor].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              }

              // de pausasHoy[0] a pausasHoy[1]
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
              const segundosAux2 = pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2
              //totalHoy = formatSeconds(totalSegundosHoy)
            } 

            //mas de dos pausas
            if (pausasHoy.length > 2) { 

              //mas de dos pausas --> primera pausa
              if (i === 0) {
                // de inicio a pausasHoy[0]
                if (semana[diaActualFor].registro.teletrabajo === true) {
                  totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                  }
                else {
                  totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                }

                const segundosAux = pausasHoy[i].inicio.seconds - semana[diaActualFor].registro.inicio.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //console.log("tres pausas 1, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundosHoy)

                //mas de dos pausas --> pausas intermedias || ultima pausa activa y sin registro.fin
              } else if (i < pausasHoy.length) {
                // de pausasHoy[i-1] a pausasHoy[i]
                if (pausasHoy[i-1].teletrabajo === true) {
                  totalSegundosHoyTeletrabajo+= pausasHoy[i].inicio.seconds - pausasHoy[i-1].fin.seconds
                }
                else {
                  totalSegundosHoyPresencial+= pausasHoy[i].inicio.seconds - pausasHoy[i-1].fin.seconds
                }

                const segundosAux = pausasHoy[i].inicio.seconds - pausasHoy[i-1].fin.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //console.log("tres pausas 2, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundosHoy)
              } 

              //mas de dos pausas --> ultima pausa con registro.fin
              if (i === pausasHoy.length-1 && semana[diaActualFor].registro.fin !== undefined) {
                // de pausasHoy[i] a fin
                if (pausasHoy[i].teletrabajo === true) {
                  totalSegundosHoyTeletrabajo+= semana[diaActualFor].registro.fin.seconds - pausasHoy[i].fin.seconds
                }
                else {
                  totalSegundosHoyPresencial+= semana[diaActualFor].registro.fin.seconds - pausasHoy[i].fin.seconds
                }

                const segundosAux = semana[diaActualFor].registro.fin.seconds - pausasHoy[i].fin.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //console.log("tres pausas 3, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundosHoy)
                //totalHoy = formatSeconds(totalSegundosHoy)
              }

              //mas de dos pausas --> ultima pausa sin registro.fin
              if (i === pausasHoy.length-1 && 
                semana[diaActualFor].registro.fin === undefined && 
                pausasHoy[i].fin !== undefined && 
                (
                  new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() || 
                  new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() - 1
                )
                ) {
                  // de pausasHoy[i] a fin
                  if (pausasHoy[i].teletrabajo === true) {
                    totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - pausasHoy[i].fin.seconds
                  }
                  else {
                    totalSegundosHoyPresencial+= new Date().getTime() / 1000 - pausasHoy[i].fin.seconds
                  }
                  
                const segundosAux = new Date().getTime() / 1000 - pausasHoy[i].fin.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //totalHoy = formatSeconds(totalSegundosHoy)
              }
            }
          }
        }
      } 
      else if (semana[diaActualFor].registro.fin === undefined) {
        if (new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() || new Date(semana[diaActualFor].registro.fecha).getDay() === new Date().getDay() - 1) {
          totalSegundosHoy = new Date().getTime() / 1000 - semana[diaActualFor].registro.inicio.seconds
          if (semana[diaActualFor].registro.teletrabajo === true) {
            totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - semana[diaActualFor].registro.inicio.seconds
          } 
          else {
            totalSegundosHoyPresencial+= new Date().getTime() / 1000 - semana[diaActualFor].registro.inicio.seconds
          }
        } 
      }
      else if (semana[diaActualFor].registro.fin !== undefined) {
        totalSegundosHoy = semana[diaActualFor].registro.fin.seconds - semana[diaActualFor].registro.inicio.seconds
        if (semana[diaActualFor].registro.teletrabajo === true) {
          totalSegundosHoyTeletrabajo+= semana[diaActualFor].registro.fin.seconds - semana[diaActualFor].registro.inicio.seconds
        } 
        else {
          totalSegundosHoyPresencial+= semana[diaActualFor].registro.fin.seconds - semana[diaActualFor].registro.inicio.seconds
        }
      }

      if (semana[diaActualFor].registro.trabajado === false) {
        totalSegundosHoy = 0
        totalSegundosHoyPresencial = 0
        totalSegundosHoyTeletrabajo = 0
      }
    }

    // console.log(totalSegundosHoyPresencial, totalSegundosHoyTeletrabajo);
    return {totalSegundosHoy, totalSegundosHoyPresencial, totalSegundosHoyTeletrabajo};
  }

  function porcentajeHorasDia() {
    let diaActualOAnterior = ""
    if (semana[diaAnterior].registro !== undefined &&
        semana[diaAnterior].registro.inicio !== undefined &&
        semana[diaAnterior].registro.fin === undefined) {
      diaActualOAnterior = diaAnterior
    }
    else {
      diaActualOAnterior = diaActual
    }

    // if (semana[diaActual].horario.inicio === "") {
    //   setPorcentajeDia("100")
    //   setLabelDia("100%")
    //   return
    // }

    let pausasHoy = "", totalSegundosHoy = 0, totalSegundosHoyPresencial = 0, totalSegundosHoyTeletrabajo = 0;
    if (semana[diaActualOAnterior].registro.pausas !== undefined && semana[diaActualOAnterior].registro.pausas !== null) {
      if (semana[diaActualOAnterior].registro !== "") {
        pausasHoy = semana[diaActualOAnterior].registro.pausas.filter(pausa => pausa.tipo !== 2)
      }
      else {
        pausasHoy = ""
      }
    } 

    if (semana[diaActualOAnterior].registro.inicio !== undefined) {
      if (pausasHoy !== "" && pausasHoy !== null && pausasHoy.length > 0) {
        for (let i = 0; i<pausasHoy.length; i++) {
          if (pausasHoy[i] !== undefined) {

            // hay 1 pausa con fin
            if (pausasHoy.length === 1 && semana[diaActualOAnterior].registro.fin !== undefined) {
              // de inicio a pausasHoy[0]
              if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              }

              // de pausasHoy[0] a fin
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[0].fin.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              const segundosAux2 = semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[0].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2
              //totalHoy = formatSeconds(totalSegundosHoy)
              //console.log("una pausa")
            } 

            //hay 1 pausa sin registro.fin
            if (pausasHoy.length === 1 && 
              semana[diaActualOAnterior].registro.fin === undefined && 
              pausasHoy[0].fin !== undefined && 
              (
                new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() || 
                new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() - 1
              )
              ) 
            { 
              // de inicio a pausasHoy[0]
              if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              }

              // de pausasHoy[0] a horaactual
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= new Date().getTime() / 1000 - pausasHoy[0].fin.seconds
              }

              
              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              const segundosAux2 = new Date().getTime() / 1000 - pausasHoy[0].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2
              //console.log(totalSegundosHoy)
            } 

            //hay 1 pausa sin registro.fin y pausa activa
            if (pausasHoy.length === 1 && semana[diaActualOAnterior].registro.fin === undefined && pausasHoy[0].fin === undefined) {
              // de inicio a pausasHoy[0]
              if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              totalSegundosHoy = segundosAux
              //console.log(totalSegundosHoy)
            } 

            //hay 2 pausas con registro.fin
            if (pausasHoy.length === 2 && semana[diaActualOAnterior].registro.fin !== undefined && (i === 0)/** Esto es para que no entre dos veces al tener dos pausas */) {
              // de inicio a pausasHoy[0]
              if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              }

              // de pausasHoy[0] a pausasHoy[1]
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }

              // de pausasHoy[1] a fin
              if (pausasHoy[1].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[1].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[1].fin.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              const segundosAux2 = pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              const segundosAux3 = semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[1].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2 + segundosAux3
              //totalHoy = formatSeconds(totalSegundosHoy)
              //console.log("2 pausas")
            }

            //hay 2 pausas sin registro.fin
            if (pausasHoy.length === 2 && 
                semana[diaActualOAnterior].registro.fin === undefined && 
                pausasHoy[1].fin !== undefined && 
                (
                  new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() || 
                  new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() - 1
                )
                && (i === 0)/** Esto es para que no entre dos veces al tener dos pausas */
                ) 
              { 
              // de inicio a pausasHoy[0]
              if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              }

              // de pausasHoy[0] a pausasHoy[1]
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }

              // de pausasHoy[1] a horaactual
              if (pausasHoy[1].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - pausasHoy[1].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= new Date().getTime() / 1000 - pausasHoy[1].fin.seconds
              }


              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              const segundosAux2 = pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              const segundosAux3 = new Date().getTime() / 1000 - pausasHoy[1].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2 + segundosAux3
              //totalHoy = formatSeconds(totalSegundosHoy)
            }  

            //hay 2 pausas sin registro.fin y pausa activa
            if (pausasHoy.length === 2 && semana[diaActualOAnterior].registro.fin === undefined && pausasHoy[1].fin === undefined && (i === 0)/** Esto es para que no entre dos veces al tener dos pausas */) { 
              // de inicio a pausasHoy[0]
              if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }
              else {
                totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              }

              // de pausasHoy[0] a pausasHoy[1]
              if (pausasHoy[0].teletrabajo === true) {
                totalSegundosHoyTeletrabajo+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }
              else {
                totalSegundosHoyPresencial+= pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              }

              const segundosAux = pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
              const segundosAux2 = pausasHoy[1].inicio.seconds - pausasHoy[0].fin.seconds
              totalSegundosHoy = segundosAux + segundosAux2
              //totalHoy = formatSeconds(totalSegundosHoy)
            } 

            //mas de dos pausas
            if (pausasHoy.length > 2) { 

              //mas de dos pausas --> primera pausa
              if (i === 0) {
                // de inicio a pausasHoy[0]
                if (semana[diaActualOAnterior].registro.teletrabajo === true) {
                  totalSegundosHoyTeletrabajo+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                  }
                else {
                  totalSegundosHoyPresencial+= pausasHoy[0].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                }

                const segundosAux = pausasHoy[i].inicio.seconds - semana[diaActualOAnterior].registro.inicio.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //console.log("tres pausas 1, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundosHoy)

                //mas de dos pausas --> pausas intermedias || ultima pausa activa y sin registro.fin
              } else if (i < pausasHoy.length) {
                // de pausasHoy[i-1] a pausasHoy[i]
                if (pausasHoy[i-1].teletrabajo === true) {
                  totalSegundosHoyTeletrabajo+= pausasHoy[i].inicio.seconds - pausasHoy[i-1].fin.seconds
                }
                else {
                  totalSegundosHoyPresencial+= pausasHoy[i].inicio.seconds - pausasHoy[i-1].fin.seconds
                }

                const segundosAux = pausasHoy[i].inicio.seconds - pausasHoy[i-1].fin.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //console.log("tres pausas 2, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundosHoy)
              } 

              //mas de dos pausas --> ultima pausa con registro.fin
              if (i === pausasHoy.length-1 && semana[diaActualOAnterior].registro.fin !== undefined) {
                // de pausasHoy[i] a fin
                if (pausasHoy[i].teletrabajo === true) {
                  totalSegundosHoyTeletrabajo+= semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[i].fin.seconds
                }
                else {
                  totalSegundosHoyPresencial+= semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[i].fin.seconds
                }

                const segundosAux = semana[diaActualOAnterior].registro.fin.seconds - pausasHoy[i].fin.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //console.log("tres pausas 3, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundosHoy)
                //totalHoy = formatSeconds(totalSegundosHoy)
              }

              //mas de dos pausas --> ultima pausa sin registro.fin
              if (i === pausasHoy.length-1 && 
                semana[diaActualOAnterior].registro.fin === undefined && 
                pausasHoy[i].fin !== undefined && 
                (
                  new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() || 
                  new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() - 1
                )
                ) {
                  // de pausasHoy[i] a fin
                  if (pausasHoy[i].teletrabajo === true) {
                    totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - pausasHoy[i].fin.seconds
                  }
                  else {
                    totalSegundosHoyPresencial+= new Date().getTime() / 1000 - pausasHoy[i].fin.seconds
                  }
                  
                const segundosAux = new Date().getTime() / 1000 - pausasHoy[i].fin.seconds
                totalSegundosHoy = totalSegundosHoy + segundosAux
                //totalHoy = formatSeconds(totalSegundosHoy)
              }
            }
          }
        }
      } 
      else if (semana[diaActualOAnterior].registro.fin === undefined) {
        if (new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() || new Date(semana[diaActualOAnterior].registro.fecha).getDay() === new Date().getDay() - 1) {
          totalSegundosHoy = new Date().getTime() / 1000 - semana[diaActualOAnterior].registro.inicio.seconds
          if (semana[diaActualOAnterior].registro.teletrabajo === true) {
            totalSegundosHoyTeletrabajo+= new Date().getTime() / 1000 - semana[diaActualOAnterior].registro.inicio.seconds
          } 
          else {
            totalSegundosHoyPresencial+= new Date().getTime() / 1000 - semana[diaActualOAnterior].registro.inicio.seconds
          }
        } 
      }
      else if (semana[diaActualOAnterior].registro.fin !== undefined) {
        totalSegundosHoy = semana[diaActualOAnterior].registro.fin.seconds - semana[diaActualOAnterior].registro.inicio.seconds
        if (semana[diaActualOAnterior].registro.teletrabajo === true) {
          totalSegundosHoyTeletrabajo+= semana[diaActualOAnterior].registro.fin.seconds - semana[diaActualOAnterior].registro.inicio.seconds
        } 
        else {
          totalSegundosHoyPresencial+= semana[diaActualOAnterior].registro.fin.seconds - semana[diaActualOAnterior].registro.inicio.seconds
        }
      }

      if (semana[diaActualOAnterior].registro.trabajado === false) {
        totalSegundosHoy = 0
        totalSegundosHoyPresencial = 0
        totalSegundosHoyTeletrabajo = 0
      }
    }


    let segundosTotalesDiarios = 0
    if (semana[diaActualOAnterior].horario.dobleDia === true) {
      const arrIni = (semana[diaActualOAnterior].horario.inicio).split(":")
      const arrFin = (semana[diaActualOAnterior].horario.fin).split(":")
      const segundosInicio = parseInt(arrIni[0]) * 3600 + parseInt(arrIni[1] * 60)
      const segundosFin = parseInt(arrFin[0]) * 3600 + parseInt(arrFin[1] * 60)
      segundosTotalesDiarios = segundosFin + 1440 * 60 - segundosInicio
    }
    else if (semana[diaActualOAnterior].horario.inicioTarde !== "") {
      const arrIni = (semana[diaActualOAnterior].horario.inicio).split(":")
      const arrFin = (semana[diaActualOAnterior].horario.fin).split(":")
      const segundosInicio = parseInt(arrIni[0]) * 3600 + parseInt(arrIni[1] * 60)
      const segundosFin = parseInt(arrFin[0]) * 3600 + parseInt(arrFin[1] * 60)
      const segundosTotalesDiariosMañana = segundosFin - segundosInicio

      const arrIniTarde = (semana[diaActualOAnterior].horario.inicioTarde).split(":")
      const arrFinTarde = (semana[diaActualOAnterior].horario.finTarde).split(":")
      const segundosInicioTarde = parseInt(arrIniTarde[0]) * 3600 + parseInt(arrIniTarde[1] * 60)
      const segundosFinTarde = parseInt(arrFinTarde[0]) * 3600 + parseInt(arrFinTarde[1] * 60)
      const segundosTotalesDiariosTarde = segundosFinTarde - segundosInicioTarde
      segundosTotalesDiarios = segundosTotalesDiariosMañana + segundosTotalesDiariosTarde
    }
    else {
      const arrIni = (semana[diaActualOAnterior].horario.inicio).split(":")
      const arrFin = (semana[diaActualOAnterior].horario.fin).split(":")
      const segundosInicio = parseInt(arrIni[0]) * 3600 + parseInt(arrIni[1] * 60)
      const segundosFin = parseInt(arrFin[0]) * 3600 + parseInt(arrFin[1] * 60)
      segundosTotalesDiarios = segundosFin - segundosInicio
    }

    if (semana[diaActualOAnterior].registro.trabajado === true) {
      setLabelDia(`${(totalSegundosHoy * 100 / segundosTotalesDiarios).toFixed(2)}% - ${formatSeconds(totalSegundosHoy)} horas`)

      // setLabelDiaPresencial(`${(totalSegundosHoyPresencial * 100 / segundosTotalesDiarios).toFixed(2)}% - ${formatSeconds(totalSegundosHoyPresencial)} horas`)
      setLabelDiaPresencial({porcentaje: parseFloat((totalSegundosHoyPresencial * 100 / segundosTotalesDiarios).toFixed(2)), horas: formatSeconds(totalSegundosHoyPresencial)})

      // setLabelDiaTeletrabajo(`${(totalSegundosHoyTeletrabajo * 100 / segundosTotalesDiarios).toFixed(2)}% - ${formatSeconds(totalSegundosHoyTeletrabajo)} horas`)
      setLabelDiaTeletrabajo({porcentaje: parseFloat((totalSegundosHoyTeletrabajo * 100 / segundosTotalesDiarios).toFixed(2)), horas: formatSeconds(totalSegundosHoyTeletrabajo)})
        
    }
    else {
      setLabelDia(``)
      setLabelDiaPresencial(``)
      setLabelDiaTeletrabajo(``)
    }
  }

  function porcentajeHorasSemana() {
    let segundosHechosSemana = 0, segundosHechosSemanaPresencial = 0, segundosHechosSemanaTeletrabajo = 0;
    for (let i = 1; i <= 7; i++) {
      segundosHechosSemana = segundosHechosSemana + calcPorcentajeHorasSemana(i).totalSegundosHoy;
      segundosHechosSemanaPresencial = segundosHechosSemanaPresencial + calcPorcentajeHorasSemana(i).totalSegundosHoyPresencial;
      segundosHechosSemanaTeletrabajo = segundosHechosSemanaTeletrabajo + calcPorcentajeHorasSemana(i).totalSegundosHoyTeletrabajo;
    }

    // console.log(segundosHechosSemana, segundosHechosSemanaPresencial, segundosHechosSemanaTeletrabajo);

    let segundosTotalesSemanales = 0, segundosTotalesSemanalesPresencial = 0, segundosTotalesSemanalesTeletrabajo = 0;
    for (let i = 1; i <= 7; i++) {
      segundosTotalesSemanales = calcHorasSemanales(i) * 60 + segundosTotalesSemanales
      segundosTotalesSemanalesPresencial = calcHorasSemanales(i) * 60 + segundosTotalesSemanalesPresencial
      segundosTotalesSemanalesTeletrabajo = calcHorasSemanales(i) * 60 + segundosTotalesSemanalesTeletrabajo
    }
    setLabelSemana(`${(segundosHechosSemana * 100 / segundosTotalesSemanales).toFixed(2)}% - ${formatSeconds(segundosHechosSemana)} horas`)

    // setLabelSemanaPresencial(`${(segundosHechosSemanaPresencial * 100 / segundosTotalesSemanalesPresencial).toFixed(2)}% - ${formatSeconds(segundosHechosSemanaPresencial)} horas`)
    setLabelSemanaPresencial({porcentaje: parseFloat((segundosHechosSemanaPresencial * 100 / segundosTotalesSemanalesPresencial).toFixed(2)), horas: formatSeconds(segundosHechosSemanaPresencial)})
    
    // setLabelSemanaTeletrabajo(`${(segundosHechosSemanaTeletrabajo * 100 / segundosTotalesSemanalesTeletrabajo).toFixed(2)}% - ${formatSeconds(segundosHechosSemanaTeletrabajo)} horas`)
    setLabelSemanaTeletrabajo({porcentaje: parseFloat((segundosHechosSemanaTeletrabajo * 100 / segundosTotalesSemanalesTeletrabajo).toFixed(2)), horas: formatSeconds(segundosHechosSemanaTeletrabajo)})
  }

  return (
    <>
      <section className="hoursDaysWeekContainer">
        <article>
          <div className="text-bold font-size-2-rem">Dia</div>
          {/* <div onClick={() => { if(!hasModalBeenSeen) {setShowModal(true); console.log(semana) }}} className="text-bold font-size-2-rem">Dia</div> */}
          <hr className="pm-0"/>
          <div className="text-bold font-size-2_5-rem">{tiempoDia}</div>
          <hr className="pm-0"/>
          <div className="text-bold font-size-1_25-rem">Horas</div>
          <div className="progresscss">
            {labelDiaPresencial && 
            <>
                <div
                  className="progressbarcss presencial"
                  style={{ width: `${labelDiaPresencial.porcentaje}%` }}
                >
                  {0 < labelDiaPresencial.porcentaje && labelDiaPresencial.porcentaje < MIN_PERCENTAJE &&
                    <> {labelDiaPresencial.porcentaje.toFixed(2)}% </>
                  }
                  {MIN_PERCENTAJE <= labelDiaPresencial.porcentaje && labelDiaPresencial.porcentaje <= MAX_PERCENTAJE &&
                    <> {labelDiaPresencial.porcentaje.toFixed(2)}% - {labelDiaPresencial.horas}h </>
                  }
                  {MAX_PERCENTAJE < labelDiaPresencial.porcentaje &&
                    <> {labelDiaPresencial.porcentaje.toFixed(2)}% - {labelDiaPresencial.horas} horas </>
                  }
                </div>
              </>
            }

            {labelDiaTeletrabajo &&
              <>
                <div
                  className="progressbarcss teletrabajo"
                  style={{ width: `${labelDiaTeletrabajo.porcentaje}%` }}
                >
                  {0 < labelDiaTeletrabajo.porcentaje && labelDiaTeletrabajo.porcentaje < MIN_PERCENTAJE &&
                    <> {labelDiaTeletrabajo.porcentaje.toFixed(2)}% </>
                  }
                  {MIN_PERCENTAJE <= labelDiaTeletrabajo.porcentaje && labelDiaTeletrabajo.porcentaje <= MAX_PERCENTAJE &&
                    <> {labelDiaTeletrabajo.porcentaje.toFixed(2)}% - {labelDiaTeletrabajo.horas}h </>
                  }
                  {MAX_PERCENTAJE < labelDiaTeletrabajo.porcentaje &&
                    <> {labelDiaTeletrabajo.porcentaje.toFixed(2)}% - {labelDiaTeletrabajo.horas} horas </>
                  }
                </div>
              </>
            }
            
          </div>
        </article>
        <article>
          <div className="text-bold font-size-2-rem">Semana</div>
          <hr className="pm-0"/>
          <div className="text-bold font-size-2_5-rem">{tiempoSemana}</div>
          <hr className="pm-0"/>
          <div className="text-bold font-size-1_25-rem">Horas</div>
          <div className="progresscss">
            {labelSemanaPresencial && 
              <>
                <div
                  className="progressbarcss presencial"
                  style={{ width: `${labelSemanaPresencial.porcentaje}%` }}
                >
                  {0 < labelSemanaPresencial.porcentaje && labelSemanaPresencial.porcentaje < MIN_PERCENTAJE &&
                    <> {labelSemanaPresencial.porcentaje.toFixed(2)}% </>
                  }
                  {MIN_PERCENTAJE <= labelSemanaPresencial.porcentaje && labelSemanaPresencial.porcentaje <= MAX_PERCENTAJE &&
                    <> {labelSemanaPresencial.porcentaje.toFixed(2)}% - {labelSemanaPresencial.horas}h </>
                  }
                  {MAX_PERCENTAJE < labelSemanaPresencial.porcentaje &&
                    <> {labelSemanaPresencial.porcentaje.toFixed(2)}% - {labelSemanaPresencial.horas} horas </>
                  }
                </div>
              </>
            }
            {labelSemanaTeletrabajo &&
              <>
                <div
                  className="progressbarcss teletrabajo"
                  style={{ width: `${labelSemanaTeletrabajo.porcentaje}%` }}
                >
                  {0 < labelSemanaTeletrabajo.porcentaje && labelSemanaTeletrabajo.porcentaje < MIN_PERCENTAJE &&
                    <> {labelSemanaTeletrabajo.porcentaje.toFixed(2)}% </>
                  }
                  {MIN_PERCENTAJE <= labelSemanaTeletrabajo.porcentaje && labelSemanaTeletrabajo.porcentaje <= MAX_PERCENTAJE &&
                    <> {labelSemanaTeletrabajo.porcentaje.toFixed(2)}% - {labelSemanaTeletrabajo.horas}h </>
                  }
                  {MAX_PERCENTAJE < labelSemanaTeletrabajo.porcentaje &&
                    <> {labelSemanaTeletrabajo.porcentaje.toFixed(2)}% - {labelSemanaTeletrabajo.horas} horas </>
                  }
                </div>
              </>
            }
            </div>
        </article>
      </section>
      {showModal && (
        <div onClick={() => {setShowModal(false); setHasModalBeenSeen(true)}} className="modal-popup-overlay">
          <div onClick={(e) => e.stopPropagation()} className="modal-popup-container">
            <h2 className="modal-popup-title">¡Alerta!</h2>
            <p>Han pasado 15 minutos desde que terminó su jornada</p>
            <button style={{marginTop: "20px"}} className="acceptButton" onClick={() => {setShowModal(false); setHasModalBeenSeen(true)}}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  )
}
